<div class="error-bar mx-auto" [ngClass]="showBorder ? 'general-error-color-scheme' : ''">
  <div
    *ngIf="redWidth > 0"
    class="red-error pill-section rounded-left"
    [ngClass]="amberWidth == 0 && greenWidth == 0 ? 'rounded-right' : ''"
    [style.width.%]="redWidth"
    [style.background]="colorPallete.error.bgColor"
    [style.color]="colorPallete.error.textColor"
  >
    <span class="percentage" *ngIf="showPercent">{{ redWidth }} %</span>
  </div>
  <div
    *ngIf="amberWidth > 0"
    class="amber-error pill-section"
    [ngClass]="redWidth === 0 && greenWidth == 0 ? 'rounded-left rounded-right' : redWidth === 0 ? 'rounded-left' : greenWidth === 0 ? 'rounded-right' : ''"
    [style.width.%]="amberWidth"
    [style.background]="colorPallete.mistake.bgColor"
    [style.color]="colorPallete.mistake.textColor"
  >
    <span class="percentage" *ngIf="showPercent">{{ amberWidth }} %</span>
  </div>
  <div
    *ngIf="greenWidth > 0"
    class="no-error pill-section rounded-right"
    [style.width.%]="greenWidth"
    [ngClass]="amberWidth == 0 && redWidth == 0 ? 'rounded-left' : ''"
    [style.background]="colorPallete.check.bgColor"
    [style.color]="colorPallete.check.textColor"
  >
    <span class="percentage" *ngIf="showPercent">{{ greenWidth }} %</span>
  </div>
</div>
